import { TOGGLE_MAIN_MENU } from '../types'

export const toggleMenu = () => ({
  type: TOGGLE_MAIN_MENU
})
